// extracted by mini-css-extract-plugin
export default {"box":"Inspotlight_box__nFyIV","imge":"Inspotlight_imge__m7t7b","title":"Inspotlight_title__D0HBe","des":"Inspotlight_des__Ab-in"};